/**
 * The site edit lock's resource type (#398 C13a, D-163), the same string the server's jobs lock
 * under (`SiteLock.ResourceType`, AGWA.Auth/Locking/SiteLock.cs). The resource id is the site's
 * LoginSite id. A site's own details, its Change Contact and its deactivation take it; its
 * operation types and its people's assignments are their own records and do not.
 */
export const SITE_LOCK_RESOURCE = 'Site';
